import React from "react";
import { Button } from '@mui/material'
import withModal from '../../Modal';

const warningModal = (props: any) => {

    return (
    <div className='modal' style={{ display: 'block', zIndex: 1200, position: 'fixed', top: '20%' }} role='dialog'>
            <div className='modal-dialog'>
                <div className='modal-content'>
                    <div className='modal-body'>
                        <div className='row'>
                            <span style={{ paddingLeft: '5%'}}>
                                <b>WICHTIG:</b>
                                {props.text}
                            </span>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <Button
                            className='btn'
                            color='secondary'
                            variant='contained'
                            onClick={() => props.hide()}>
                            Abbrechen
                                </Button>
                        <Button
                            className='btn'
                            color='primary'
                            variant='contained'
                            onClick={() => { 
                                props.confirm()
                                props.hide()
                            }}>
                            Ja
                                </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withModal(warningModal)